import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.PortfolioConfigEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.PortfolioConfigList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.PortfolioConfigCreate })));

export default { edit, list, create };
